import { PRESETS_KEY } from './defaults.js'

export const builtinPresets = {
    'Dust': {
        shape: 'sphere', shapeText: 'DEEP', shapeScale: 1.1,
        morphEnabled: false, morphTarget: 'text', morphSpeed: 0.5, morphStrength: 5,
        particleSize: 0.033, particleShape: 0, shapeSoftness: 0.7,
        particleColor: '#a7a7a7', colorShift: '#a4a4a4', backgroundColor: '#010a0f',
        opacityVariance: 1.63, colorVariance: 2.64, sizeVariance: 1.6,
        flashIntensity: 6, dimIntensity: 1.66,
        flowInfluence: 1, flowStrength: 3.913, flowFrequency: 0.522,
        mouseRadius: 10, mouseAspect: 3.0, suckStrength: 10, windStrength: 8, mouseTrail: 0,
        particleCount: 58000, respawnRate: 0.29,
        damping: 2, turbulenceStrength: 1.6, turbulenceFrequency: 2.7,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: true, autoRotateSpeed: 0.8,
        bloomEnabled: true, bloomStrength: 0.6, bloomRadius: 0.3, bloomThreshold: 0.4,
        trailEnabled: true, trailAmount: 40, trailResolutionScale: 0.75, trailBlurAmount: 0.4, trailBrightPersist: 0.5, trailBlendMode: 0,
        dofEnabled: true, dofFocus: 15, dofAperture: 0.215, dofMaxBlur: 2,
        toneMapping: 4, exposure: 1,
    },
    'Caravaggio': {
        shape: 'image', imageFile: 'caravaggio.jpg', shapeScale: 1.0,
        morphEnabled: false, morphTarget: 'sphere', morphSpeed: 0.5, morphStrength: 5,
        particleSize: 0.04, particleShape: 0, shapeSoftness: 0.85,
        particleColor: '#cc8844', colorShift: '#ff6633', backgroundColor: '#000000',
        opacityVariance: 0.3, colorVariance: 0.15, sizeVariance: 0.8,
        flashIntensity: 1.5, dimIntensity: 0.3,
        flowInfluence: 0.15, flowStrength: 0.4, flowFrequency: 0.3,
        mouseRadius: 8, mouseAspect: 2, suckStrength: 15, windStrength: 5, mouseTrail: 0,
        particleCount: 533000, respawnRate: 0.07,
        damping: 2.5, turbulenceStrength: 0.6, turbulenceFrequency: 0.8,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: false, autoRotateSpeed: 0,
        bloomEnabled: false, bloomStrength: 0.54, bloomRadius: 1.63, bloomThreshold: 0.88,
        trailEnabled: true, trailAmount: 57.6, trailResolutionScale: 0.75, trailBlurAmount: 0.4, trailBrightPersist: 0, trailBlendMode: 0,
        dofEnabled: true, dofFocus: 18, dofAperture: 0.08, dofMaxBlur: 1,
        toneMapping: 4, exposure: 1,
        revealEnabled: false, revealRadius: 4, revealSoftness: 0.6,
    },
    'Van Gogh': {
        shape: 'ply', plyFile: 'vangogh.ply', shapeScale: 1.15,
        morphEnabled: false, morphTarget: 'sphere', morphSpeed: 0.5, morphStrength: 5,
        particleSize: 0.043, particleShape: 0, shapeSoftness: 0.23,
        particleColor: '#4466aa', colorShift: '#ffcc44', backgroundColor: '#000000',
        opacityVariance: 0.98, colorVariance: 0, sizeVariance: 1.85,
        flashIntensity: 1.6, dimIntensity: 0.8, saturation: 3,
        flowInfluence: 0.38, flowStrength: 8.152, flowFrequency: 2.174,
        mouseRadius: 8, mouseAspect: 2, suckStrength: 15, windStrength: 5, mouseTrail: 0,
        particleCount: 511000, respawnRate: 0.59,
        damping: 1.6, turbulenceStrength: 1.3, turbulenceFrequency: 0.4,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: false, autoRotateSpeed: 0,
        bloomEnabled: true, bloomStrength: 0.87, bloomRadius: 0.71, bloomThreshold: 0.73,
        trailEnabled: true, trailAmount: 63, trailResolutionScale: 0.75, trailBlurAmount: 0.24, trailBrightPersist: 0.26, trailBlendMode: 0,
        dofEnabled: false, dofFocus: 26.2, dofAperture: 0.012, dofMaxBlur: 2.99,
        toneMapping: 4, exposure: 0.5,
        revealEnabled: false, revealRadius: 4, revealSoftness: 0.6,
    },
    'Abyss': {
        shape: 'sphere', shapeText: 'DEEP', shapeScale: 1.0,
        morphEnabled: false,
        particleSize: 0.033, particleColor: '#00ffcc', colorShift: '#0044ff', backgroundColor: '#010a0f',
        opacityVariance: 1.92, colorVariance: 2.09, sizeVariance: 1.14,
        flashIntensity: 9.9, dimIntensity: 3.0,
        flowInfluence: 1.0, flowStrength: 3.152, flowFrequency: 0.522,
        mouseRadius: 5.54, mouseAspect: 1.5, suckStrength: 6, windStrength: 8, mouseTrail: 0,
        particleCount: 46000, respawnRate: 0.29,
        damping: 2.0, turbulenceStrength: 1.6, turbulenceFrequency: 2.7,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: true, autoRotateSpeed: 0.8,
        bloomEnabled: true, bloomStrength: 0.6, bloomRadius: 0.3, bloomThreshold: 0.4,
        trailEnabled: true, trailAmount: 40, trailResolutionScale: 0.75, trailBlurAmount: 0.4, trailBrightPersist: 0.5, trailBlendMode: 0,
        toneMapping: 4, exposure: 1.0,
    },
    'Pulse': {
        shape: 'heart', shapeText: '', shapeScale: 1.0,
        morphEnabled: false,
        particleSize: 0.06, particleColor: '#ff1144', colorShift: '#ff6688', backgroundColor: '#0a0004',
        opacityVariance: 0.5, colorVariance: 0.4,
        flowInfluence: 0.4, flowStrength: 1.5, flowFrequency: 0.4,
        mouseRadius: 6, mouseAspect: 2.0, suckStrength: 12, windStrength: 5, mouseTrail: 0,
        particleCount: 25000, respawnRate: 0.2,
        damping: 1.8, turbulenceStrength: 2.5, turbulenceFrequency: 1.2,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: true, autoRotateSpeed: 1.5,
        bloomEnabled: true, bloomStrength: 0.65, bloomRadius: 0.35, bloomThreshold: 0.35,
        trailEnabled: true, trailAmount: 35, trailResolutionScale: 0.75, trailBlurAmount: 0.5, trailBrightPersist: 0.5, trailBlendMode: 0,
        toneMapping: 4, exposure: 1.0,
    },
    'Helix': {
        shape: 'spiral', shapeText: '', shapeScale: 1.2,
        morphEnabled: false,
        particleSize: 0.035, particleColor: '#22ccff', colorShift: '#ff44aa', backgroundColor: '#020210',
        opacityVariance: 0.3, colorVariance: 0.9,
        flowInfluence: 0.6, flowStrength: 2.5, flowFrequency: 0.6,
        mouseRadius: 5, mouseAspect: 1.0, suckStrength: 20, windStrength: 10, mouseTrail: 0,
        particleCount: 35000, respawnRate: 0.25,
        damping: 1.5, turbulenceStrength: 3.0, turbulenceFrequency: 2.0,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: true, autoRotateSpeed: 3.0,
        bloomEnabled: true, bloomStrength: 0.55, bloomRadius: 0.3, bloomThreshold: 0.4,
        trailEnabled: true, trailAmount: 45, trailResolutionScale: 0.75, trailBlurAmount: 0.35, trailBrightPersist: 0.4, trailBlendMode: 0,
        toneMapping: 4, exposure: 1.0,
    },
    'Nova': {
        shape: 'torusknot', shapeText: '', shapeScale: 0.9,
        morphEnabled: false,
        particleSize: 0.03, particleColor: '#ffcc44', colorShift: '#ff4400', backgroundColor: '#000000',
        opacityVariance: 0.2, colorVariance: 0.8,
        flowInfluence: 0.9, flowStrength: 6, flowFrequency: 0.5,
        mouseRadius: 10, mouseAspect: 1.0, suckStrength: 25, windStrength: 14, mouseTrail: 0,
        particleCount: 45000, respawnRate: 0.4,
        damping: 0.9, turbulenceStrength: 5.5, turbulenceFrequency: 2.5,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: true, autoRotateSpeed: 2.5,
        bloomEnabled: true, bloomStrength: 0.55, bloomRadius: 0.25, bloomThreshold: 0.4,
        trailEnabled: true, trailAmount: 30, trailResolutionScale: 0.65, trailBlurAmount: 0.25, trailBrightPersist: 0.35, trailBlendMode: 0,
        toneMapping: 4, exposure: 0.95,
    },
    'Morph': {
        shape: 'text', shapeText: 'LOVE', shapeScale: 1.0,
        morphEnabled: true, morphTarget: 'heart', morphSpeed: 0.3, morphStrength: 8.0,
        particleSize: 0.045, particleColor: '#ff3366', colorShift: '#ffaacc', backgroundColor: '#060008',
        opacityVariance: 0.4, colorVariance: 0.6,
        flowInfluence: 0.3, flowStrength: 0.5, flowFrequency: 0.3,
        mouseRadius: 6, mouseAspect: 2.0, suckStrength: 10, windStrength: 6, mouseTrail: 0,
        particleCount: 30000, respawnRate: 0.25,
        damping: 2.5, turbulenceStrength: 1.0, turbulenceFrequency: 0.8,
        enableZoom: true, enablePan: true, enableRotate: true,
        autoRotate: true, autoRotateSpeed: 1.5,
        bloomEnabled: true, bloomStrength: 0.55, bloomRadius: 0.3, bloomThreshold: 0.35,
        trailEnabled: true, trailAmount: 30, trailResolutionScale: 0.75, trailBlurAmount: 0.3, trailBrightPersist: 0.4, trailBlendMode: 0,
        toneMapping: 4, exposure: 1.0,
    },
}

export let userPresets = {}
try {
    userPresets = JSON.parse(localStorage.getItem(PRESETS_KEY)) || {}
} catch(e) {}

export const saveUserPresets = () => {
    localStorage.setItem(PRESETS_KEY, JSON.stringify(userPresets))
}
